

import * as projectConst from './constants';
import { debug } from 'util';


export default {
    [projectConst.getProjects](state, ListProjectResult) {
        state.list = ListProjectResult.ListProjectResult.ProjectList;
        state.total = ListProjectResult.ListProjectResult.Total
    }
};